export function optionDataHasStringId(data: unknown): data is { id: string } {
  if (!data || typeof data !== 'object') return false;
  if (!('id' in data)) return false;
  const identifier = (data as { id: unknown }).id;
  return typeof identifier === 'string';
}
